<template>
  <div class="failure-container">
    <img
      @click="$emit('closeDialog')"
      class="close-icon"
      src="../../assets/icons/close.png"
      alt="Close"
    >
    <h1 class="header-text">
      <span>Detalji kvara
        <div class="header-text-line"></div>
      </span>
    </h1>
    <div class="failure-single">
      <div class="user clearAfterFloats">
        <div class="text-center">
          <img :src="failure.ReportedBy.ProfileUrl" alt="Korisnička slika">
        </div>
        <div>
          <p>{{ failure.ReportedBy.Name }}</p>
        </div>
      </div>
      <div class="details">
        <p>
          <b>Vrijeme:</b>
          {{ failure.ReportTime }}
        </p>
        <p>
          <b>Datum:</b>
          {{ failure.ReportDate }}
        </p>
        <p>
          <b>Studio:</b>
          {{ failure.Studio }}
        </p>
      </div>
      <div class="comment">
        <p class="comment-header">Opis:</p>
        <p>{{ failure.Description }}</p>
      </div>
      <div class="text-right">
        <p v-if="failure.IsSolved">Ovaj kvar je uspješno otklonjen</p>
        <v-btn class="main-btn" v-else @click="markFailureAsSolved">Otkloni kvar</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["failureId", "failureDialog"],
  data() {
    return {
      failure: {}
    };
  },
  methods: {
    getFailure() {
      this.$store.state.services.failureService
        .get(this.failureId)
        .then(response => {
          this.failure = response.data;
        });
    },
    markFailureAsSolved() {
      var update = { FailureId: this.failureId };
      this.$store.state.services.failureService
        .update(update)
        .then(response => {
          this.getFailure();
          this.$emit("failureSolved");
          this.$store.dispatch("setResponseMessage", response.data);
        });
    }
  },
  watch: {
    failureId() {
      this.getFailure();
    }
  }
};
</script>

<style scoped>
.failure-container {
  padding: 10px;
  padding-bottom: 0;
  position: relative;
}
.failure-single {
  padding: 20px;
  padding-bottom: 10px;
}
.header-text {
  margin-bottom: 20px;
}

.user {
  position: relative;
}

.user div {
  float: left;
}

.user img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}

.user div:nth-child(2) p {
  line-height: 50px;
  margin: 0;
  vertical-align: middle;
  font-weight: 500;
  font-size: 18px;
}
.details p {
  margin: 5px 0;
}
.comment {
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  margin: 8px 0;
}
.comment-header {
  font-style: italic;
  margin: 10px 0;
}
</style>
